import { sh } from '@tpluscode/rdf-ns-builders';
import s2q from '../../ns.js';
import { PatternBuilder } from '../nodeExpression/NodeExpression.js';
export class NodeExpressionTarget {
    constructor(node, builder) {
        this.builder = builder;
        this.expression = this.builder.nodeExpression(node.out(sh.expression));
    }
    buildPatterns(arg) {
        const subject = arg.variable();
        const object = arg.variable();
        const { patterns: [pattern] } = this.expression.build({
            object,
            subject,
            variable: arg.variable,
            rootPatterns: [],
        }, new PatternBuilder());
        let select;
        const aliasReturnVar = {
            expression: this.expression.rootIsFocusNode ? subject : object,
            variable: arg.focusNode,
        };
        if (pattern.type === 'query') {
            const variables = pattern.variables;
            select = {
                ...pattern,
                variables: [...variables, aliasReturnVar],
            };
        }
        else {
            select = {
                type: 'query',
                queryType: 'SELECT',
                variables: [aliasReturnVar],
                where: [pattern],
                prefixes: {},
            };
        }
        return {
            whereClause: [{
                    type: 'group',
                    patterns: [select],
                }],
            constructClause: [],
        };
    }
}
NodeExpressionTarget.type = s2q.NodeExpressionTarget;
